module.exports = __webpack_public_path__ + "media/images/icons/outlined/import-a3df9d205541e3d10bf169ea901d6563.svg";